/*
 * PurrEase review pop-up (Oct 6 2026, theme v9).
 * Markup and styles: sections/purrease-review-pop.liquid (header group).
 *
 * Modes, picked from the live header layout:
 *   full  - desktop at the top of the page: the card hangs from the empty part of the header
 *   slim  - desktop once scrolled: a one-line version that stays inside the sticky header
 *   phone - phones/tablets with no room in the header: pops down from the top of the screen
 *   photo - phones, optional setting: sits on the bottom of the Calm Plan product photo
 * It hides while the Calm Plan reveal, the cart drawer or the menu drawer is open, and on
 * phones while someone is typing. Dismissing it keeps it closed for the rest of the visit.
 */
(function () {
  'use strict';
  if (window.__peReviewPop) return;
  window.__peReviewPop = true;

  var KEY = 'pe-review-pop';
  var reducedMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function readStore() {
    try {
      return JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }
  function writeStore(v) {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {}
  }
  function luminance(color) {
    var m = String(color).match(/[0-9.]+/g);
    if (!m || m.length < 3) return 1;
    if (m.length > 3 && parseFloat(m[3]) < 0.5) return 1;
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
  }
  function pageScrollY() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.pageYOffset || 0, pw ? pw.scrollTop : 0);
  }

  function init(root) {
    if (!root || root.__peRv) return;
    root.__peRv = true;

    var design = root.getAttribute('data-design') === 'true';
    var cards = [].slice.call(root.querySelectorAll('.pe-rv__card'));
    if (!cards.length) return;
    var dots = [].slice.call(root.querySelectorAll('.pe-rv__dots i'));
    var countEl = root.querySelector('.pe-rv__count b');
    var nextBtn = root.querySelector('.pe-rv__next');
    var closeBtn = root.querySelector('.pe-rv__x');
    var line = root.querySelector('.pe-rv__line i');

    function num(attr, fallback) {
      var v = parseFloat(root.getAttribute(attr));
      return isFinite(v) ? v : fallback;
    }
    var DELAY = num('data-delay', 3) * 1000;
    var SHOW = num('data-show', 7) * 1000;
    var GAP = num('data-gap', 2) * 1000;
    var MAX = Math.max(1, Math.round(num('data-max', 4)));
    var phonePref = root.getAttribute('data-phone') || 'top';
    var themePref = root.getAttribute('data-theme') || 'auto';

    var saved = readStore();
    if (!design && saved.x) {
      root.hidden = true;
      return;
    }

    var homeParent = root.parentNode;
    var homeNext = root.nextSibling;
    var idx = (saved.i || 0) % cards.length;
    var shown = 0;
    var mode = '';
    var visible = false;
    var done = false;
    var held = false;
    var suppressed = false;
    var paused = false;
    var timer = null;
    var step = null;
    var left = 0;
    var due = 0;
    var watch = null;
    var swapT = null;
    var geo = { phone: true, right: 24, w: 400, sw: 520, hb: 66 };

    /* ---------- look ---------- */
    function applyTheme() {
      var light =
        themePref === 'light' ||
        (themePref === 'auto' &&
          !document.querySelector('.cp-bg-dark') &&
          luminance(getComputedStyle(document.body).backgroundColor) > 0.6);
      root.classList.toggle('pe-rv--light', light);
    }

    /* ---------- geometry: where is the empty part of the header? ---------- */
    function measure() {
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var header = document.querySelector('header-component') || document.querySelector('.header-section');
      var actions = document.querySelector('header-actions') || (header && header.querySelector('.header-actions'));
      var hb = header ? header.getBoundingClientRect() : { top: 0, bottom: 66 };
      var actionsLeft = actions ? actions.getBoundingClientRect().left : vw - 140;
      var navEnd = 0;
      if (header) {
        [].forEach.call(header.querySelectorAll('a, button, img, svg'), function (el) {
          var r = el.getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.right < actionsLeft - 1 && r.bottom > hb.top && r.top < hb.bottom) {
            navEnd = Math.max(navEnd, r.right);
          }
        });
      }
      var avail = actionsLeft - 14 - (navEnd + 18);
      geo.hb = Math.max(48, Math.round(hb.bottom));
      geo.right = Math.max(8, Math.round(vw - actionsLeft + 14));
      geo.w = Math.round(Math.min(424, avail, Math.max(392, vw * 0.27)));
      geo.sw = Math.round(Math.min(540, avail));
      geo.phone = vw < 750 || avail < 330;
      root.style.setProperty('--pe-right', geo.right + 'px');
      root.style.setProperty('--pe-w', geo.w + 'px');
      root.style.setProperty('--pe-sw', geo.sw + 'px');
    }

    function pickMode() {
      if (geo.phone) {
        if (phonePref === 'off') return 'none';
        if (phonePref === 'photo' && !design && document.querySelector('.cp-media')) return 'photo';
        return 'phone';
      }
      if (pageScrollY() < 24) return 'full';
      return geo.sw >= 360 ? 'slim' : 'none';
    }

    function placeTop() {
      if (mode === 'full') {
        root.style.setProperty('--pe-top', '10px');
      } else if (mode === 'slim') {
        var h = root.offsetHeight || 52;
        root.style.setProperty('--pe-top', Math.max(4, Math.round((geo.hb - h) / 2)) + 'px');
      }
    }

    function setModeClasses(m) {
      root.classList.toggle('pe-rv--full', m === 'full');
      root.classList.toggle('pe-rv--slim', m === 'slim');
      root.classList.toggle('pe-rv--phone', m === 'phone' || m === 'photo');
      root.classList.toggle('pe-rv--photo', m === 'photo');
      if (m === 'photo') {
        var media = document.querySelector('.cp-media');
        if (media && root.parentNode !== media) media.appendChild(root);
      } else if (root.parentNode !== homeParent && homeParent) {
        homeParent.insertBefore(root, homeNext && homeNext.parentNode === homeParent ? homeNext : null);
      }
      placeTop();
    }

    function applyMode(m) {
      if (m === mode) return;
      var prev = mode;
      mode = m;
      var animate = prev && prev !== 'none' && m !== 'none' && visible && !(reducedMq && reducedMq.matches);
      clearTimeout(swapT);
      if (animate) {
        root.classList.add('is-swap');
        swapT = setTimeout(function () {
          setModeClasses(mode);
          root.classList.remove('is-swap');
        }, 170);
      } else {
        root.classList.remove('is-swap');
        setModeClasses(m);
      }
    }

    /* ---------- when must it get out of the way? ---------- */
    function blocked() {
      if (mode === 'none' || document.hidden) return true;
      if (document.documentElement.classList.contains('pe-cr-lock')) return true; // Calm Plan reveal is open
      if (document.querySelector('dialog[open], details.menu-drawer-container[open]')) return true;
      if (mode === 'photo') {
        var host = root.parentNode && root.parentNode.getBoundingClientRect ? root.parentNode.getBoundingClientRect() : null;
        if (host && (host.bottom < 90 || host.top > window.innerHeight - 60)) return true;
      }
      if (mode === 'phone' || mode === 'photo') {
        var a = document.activeElement;
        if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true; // keyboard is up
      }
      return false;
    }

    /* ---------- timing ---------- */
    function run() {
      timer = null;
      var fn = step;
      step = null;
      if (fn) fn();
    }
    function schedule(ms, fn) {
      clearTimeout(timer);
      timer = null;
      step = fn;
      left = ms;
      if (!paused) {
        due = Date.now() + ms;
        timer = setTimeout(run, ms);
      }
    }
    function pause() {
      if (paused) return;
      paused = true;
      root.classList.add('is-paused');
      if (timer) {
        clearTimeout(timer);
        timer = null;
        left = Math.max(0, due - Date.now());
      }
    }
    function resume() {
      if (!paused || held || suppressed) return;
      paused = false;
      root.classList.remove('is-paused');
      if (step && !timer) {
        due = Date.now() + left;
        timer = setTimeout(run, left);
      }
    }

    function setCard(i) {
      idx = ((i % cards.length) + cards.length) % cards.length;
      cards.forEach(function (c, k) {
        var on = k === idx;
        c.classList.toggle('is-cur', on);
        c.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-cur', k === idx);
      });
      if (countEl) countEl.textContent = String(idx + 1);
    }
    function restartLine() {
      if (!line) return;
      line.style.animation = 'none';
      void line.offsetWidth;
      line.style.animation = '';
    }
    function remember() {
      saved.i = (idx + 1) % cards.length;
      writeStore(saved);
    }

    function showCard() {
      if (done) return;
      if (shown >= MAX) return finish();
      root.classList.add('is-instant');
      setCard(idx);
      void root.offsetWidth;
      root.classList.remove('is-instant');
      root.style.setProperty('--pe-dur', SHOW + 'ms');
      visible = true;
      root.classList.add('is-on');
      restartLine();
      placeTop();
      shown++;
      remember();
      schedule(SHOW, hideCard);
    }
    function hideCard() {
      visible = false;
      root.classList.remove('is-on');
      if (shown >= MAX) return schedule(700, finish);
      idx = (idx + 1) % cards.length;
      schedule(GAP, showCard);
    }
    function finish() {
      done = true;
      visible = false;
      root.classList.remove('is-on');
      clearTimeout(timer);
      timer = null;
      step = null;
      if (watch) clearInterval(watch);
      document.removeEventListener('scroll', tick, true);
      window.removeEventListener('resize', onResize);
    }
    function dismiss() {
      saved.x = 1;
      writeStore(saved);
      finish();
    }
    function next() {
      if (done) return;
      setCard(idx + 1);
      remember();
      restartLine();
      if (visible) schedule(SHOW, hideCard);
    }

    /* ---------- watcher ---------- */
    function tick() {
      if (done) return;
      applyMode(pickMode());
      var sup = blocked();
      if (sup && !suppressed) {
        suppressed = true;
        root.classList.add('is-sup');
        pause();
      } else if (!sup && suppressed) {
        suppressed = false;
        root.classList.remove('is-sup');
        if (visible && step === hideCard && left < 2500) {
          left = 2500; // give it a fair look when it comes back
          root.style.setProperty('--pe-dur', left + 'ms');
          restartLine();
        }
        resume();
      }
    }
    var resizeT = null;
    function onResize() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        measure();
        tick();
        placeTop();
      }, 120);
    }

    /* ---------- controls ---------- */
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismiss();
    });
    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      held = true;
      pause();
    });
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      held = false;
      resume();
    });
    root.addEventListener('focusin', function () {
      held = true;
      pause();
    });
    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && root.contains(e.relatedTarget)) return;
      held = false;
      resume();
    });

    // Phones: swipe up to dismiss, swipe sideways or tap for the next card.
    var tx = 0;
    var ty = 0;
    var moved = false;
    root.addEventListener(
      'touchstart',
      function (e) {
        var t = e.touches[0];
        tx = t.clientX;
        ty = t.clientY;
        moved = false;
        held = true;
        pause();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchmove',
      function (e) {
        var t = e.touches[0];
        if (Math.abs(t.clientX - tx) > 8 || Math.abs(t.clientY - ty) > 8) moved = true;
        if (mode === 'phone' && e.cancelable) e.preventDefault();
      },
      { passive: false }
    );
    root.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - tx;
      var dy = t.clientY - ty;
      held = false;
      var onButton = e.target && e.target.closest && e.target.closest('button');
      if (mode === 'phone' && dy < -28 && Math.abs(dy) > Math.abs(dx)) {
        dismiss();
        return;
      }
      if (!onButton) {
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) next();
        else if (!moved) next();
      }
      resume();
    });

    /* ---------- start ---------- */
    root.hidden = false;
    applyTheme();
    measure();
    applyMode(pickMode());
    setCard(idx);

    if (design) {
      // Theme editor: keep a card on screen so it can be edited; follow the selected block.
      held = true;
      visible = true;
      root.classList.add('is-on', 'is-paused');
      document.addEventListener('shopify:block:select', function (e) {
        var id = e.detail && e.detail.blockId;
        if (!id) return;
        cards.forEach(function (c, k) {
          if ((c.getAttribute('data-shopify-editor-block') || '').indexOf(id) > -1) setCard(k);
        });
      });
      window.addEventListener('resize', function () {
        measure();
        applyMode(pickMode());
      });
      document.addEventListener(
        'scroll',
        function () {
          applyMode(pickMode());
        },
        true
      );
      return;
    }

    schedule(DELAY, showCard);
    document.addEventListener('scroll', tick, { passive: true, capture: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    setTimeout(onResize, 1200);
    document.addEventListener('visibilitychange', tick);
    watch = setInterval(tick, 350);
    tick();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-pe-rv]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-pe-rv]') : null;
    if (r) init(r);
  });
})();
